import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  Token_BEGIN_ARRAY_instance = new (Token())('BEGIN_ARRAY', 0);
  Token_END_ARRAY_instance = new (Token())('END_ARRAY', 1);
  Token_BEGIN_OBJECT_instance = new (Token())('BEGIN_OBJECT', 2);
  Token_END_OBJECT_instance = new (Token())('END_OBJECT', 3);
  Token_NAME_instance = new (Token())('NAME', 4);
  Token_STRING_instance = new (Token())('STRING', 5);
  Token_NUMBER_instance = new (Token())('NUMBER', 6);
  Token_LONG_instance = new (Token())('LONG', 7);
  Token_BOOLEAN_instance = new (Token())('BOOLEAN', 8);
  Token_NULL_instance = new (Token())('NULL', 9);
  Token_END_DOCUMENT_instance = new (Token())('END_DOCUMENT', 10);
  Token_ANY_instance = new (Token())('ANY', 11);
}
var Token_BEGIN_ARRAY_instance;
var Token_END_ARRAY_instance;
var Token_BEGIN_OBJECT_instance;
var Token_END_OBJECT_instance;
var Token_NAME_instance;
var Token_STRING_instance;
var Token_NUMBER_instance;
var Token_LONG_instance;
var Token_BOOLEAN_instance;
var Token_NULL_instance;
var Token_END_DOCUMENT_instance;
var Token_ANY_instance;
var TokenClass;
function Token() {
  if (TokenClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'Token');
    TokenClass = $;
  }
  return TokenClass;
}
function Token_BEGIN_ARRAY_getInstance() {
  static_init();
  return Token_BEGIN_ARRAY_instance;
}
function Token_END_ARRAY_getInstance() {
  static_init();
  return Token_END_ARRAY_instance;
}
function Token_BEGIN_OBJECT_getInstance() {
  static_init();
  return Token_BEGIN_OBJECT_instance;
}
function Token_END_OBJECT_getInstance() {
  static_init();
  return Token_END_OBJECT_instance;
}
function Token_NAME_getInstance() {
  static_init();
  return Token_NAME_instance;
}
function Token_STRING_getInstance() {
  static_init();
  return Token_STRING_instance;
}
function Token_NUMBER_getInstance() {
  static_init();
  return Token_NUMBER_instance;
}
function Token_LONG_getInstance() {
  static_init();
  return Token_LONG_instance;
}
function Token_BOOLEAN_getInstance() {
  static_init();
  return Token_BOOLEAN_instance;
}
function Token_NULL_getInstance() {
  static_init();
  return Token_NULL_instance;
}
function Token_END_DOCUMENT_getInstance() {
  static_init();
  return Token_END_DOCUMENT_instance;
}
function Token_ANY_getInstance() {
  static_init();
  return Token_ANY_instance;
}
function ignoreUnknownKeys(ignoreUnknownKeys) {
}
function ignoreUnknownKeys_0() {
  return true;
}
var JsonReaderClass;
function JsonReader() {
  if (JsonReaderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'JsonReader');
    JsonReaderClass = $;
  }
  return JsonReaderClass;
}
//region block: exports
export {
  JsonReader as JsonReaderhn8ohc8v7l9p,
  Token_ANY_getInstance as Token_ANY_getInstance2irq9xt74psnv,
  Token_BEGIN_ARRAY_getInstance as Token_BEGIN_ARRAY_getInstanceqey9u7uiztg7,
  Token_BEGIN_OBJECT_getInstance as Token_BEGIN_OBJECT_getInstance3cbczqvg43p6l,
  Token_BOOLEAN_getInstance as Token_BOOLEAN_getInstance2lgd2p6it6acr,
  Token_END_ARRAY_getInstance as Token_END_ARRAY_getInstance3997flzdfgwf5,
  Token_END_DOCUMENT_getInstance as Token_END_DOCUMENT_getInstancebw7c8jvmh8y9,
  Token_END_OBJECT_getInstance as Token_END_OBJECT_getInstance2mjr75p0i0e8i,
  Token_LONG_getInstance as Token_LONG_getInstance1ss7l3se79ypx,
  Token_NAME_getInstance as Token_NAME_getInstance2t93ii37za3wz,
  Token_NULL_getInstance as Token_NULL_getInstance2d65is50ce53,
  Token_NUMBER_getInstance as Token_NUMBER_getInstance3n6fh3qp39hkz,
  Token_STRING_getInstance as Token_STRING_getInstance1x248xxrskx54,
};
//endregion

//# sourceMappingURL=JsonReader.mjs.map
